import * as React from 'react';

import { inject } from 'mobx-react';

import { AnalyticsStore } from 'bernie-core';

import { ExitIntentModel } from 'models/common/common-types';

import { UitkFigure } from 'uitk-react-images';
import { UitkLink, UitkLinkTheme, UitkLinkTypeSize } from 'uitk-react-link';
import { ToolbarType, UitkOverlayToolbar } from 'uitk-react-toolbar';

import { Overlay } from 'components/layout/layers/overlay';

export interface ExitIntentOverlayProps {
  exitIntent?: ExitIntentModel;
  handleDismiss?: () => void;
  analytics?: AnalyticsStore;
}

@inject('analytics')
export class ExitIntentOverlay extends React.Component<ExitIntentOverlayProps> {
  private closeBtnRef = null;
  public constructor(props) {
    super(props);
    this.closeBtnRef = React.createRef();
  }

  public componentDidMount() {
    this.setFocus();
  }

  private setFocus() {
    if (this.closeBtnRef && this.closeBtnRef.current && typeof this.closeBtnRef.current.focus === 'function') {
      this.closeBtnRef.current.focus();
    }
  }

  public render() {
    const modalClass =
      'exit-intent-modal uitk-flex uitk-flex-column uitk-flex-gap-four uitk-flex-align-items-center \
    uitk-type-center all-b-padding-six all-x-padding-twelve pwa-theme--color-white';

    const { exitIntent, handleDismiss, analytics } = this.props;

    const toolbarAnalytics = analytics.setupTracker('ExitIntent', 'close exit intent pop up');

    const message = exitIntent.message;

    return (
      <Overlay type="modal" openAnimation="slideup">
        <UitkFigure className="all-image-fit-cover" src={exitIntent.backgroundImageUrl} data-stid="exit-intent-background-image">
          <UitkOverlayToolbar type={ToolbarType.CLOSE} action={handleDismiss} buttonRef={this.closeBtnRef} analytics={toolbarAnalytics} />
          <div className={modalClass}>
            <img width="180" src={exitIntent.logoUrl} alt="Brand Logo" />
            <p className="uitk-type-600">
              <strong>
                {message.headingOne}
                <br />
                {message.headingTwo}
                <br />
                <span className="uitk-type-900" data-stid="percent-off">
                  {message.percentOff}
                </span>
              </strong>
            </p>
            <p className="uitk-type-500">
              {message.headingThree}
              <br />
              <span className="uitk-type-700">
                <strong>{message.couponCode}</strong>
              </span>
            </p>
            <p className="uitk-type-200">
              {message.termsAndConditionsOne}
              <UitkLink inline={true} theme={UitkLinkTheme.REVERSE} type={UitkLinkTypeSize.SMALL}>
                <a href={exitIntent.clickHereLinkUrl} target="_blank">
                  {message.clickHere}
                </a>
              </UitkLink>{' '}
              {message.termsAndConditionsTwo}
            </p>
          </div>
        </UitkFigure>
      </Overlay>
    );
  }
}
